// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dc0a103f","732":"aa8b379c"}[chunkId] + ".chunk.js";
};